import { createBrowserRouter, RouterProvider } from "react-router-dom";

import Main from "./layout/Main";
import Home from './pages/Home'
import About from './pages/About'
import MyOrders from './pages/MyOrders'
import TotalOrders from './pages/TotalOrders'
import NotFound from './pages/NotFound'
import { useContext } from "react";
import { UserContext } from "./layout/Root";
import NotAuth from "./pages/NotAuth";

export const links = [
   {
      path: "/",
      element: <Main />,
      children: [
         { path: '/', element: <Home />, text: 'Home', notAllow: [] },
         { path: '/about', element: <About />, text: 'About', notAllow: ['host'] },
         { path: '/my-orders', element: <MyOrders />, text: 'my orders', notAllow: ['host'] },
         { path: '/total-orders', element: <TotalOrders />, text: 'orders', notAllow: ['client'] },
         { path: '/404', element: <NotFound />, text: '', notAllow: [], notInMenu: true },
         { path: '/*', element: <NotFound />, text: '', notAllow: [], notInMenu: true },
      ]
   }
]

export default function Router() {
   const [user] = useContext(UserContext)
   const filteredLinks = links.map(group => ({ ...group, children: group.children.map(link => !link.notAllow.includes(user.type) ? link : ({ ...link, element: <NotAuth /> })) }))
   const router = createBrowserRouter(filteredLinks);

   return (
      <RouterProvider router={router} />
   )
}
